import { css } from 'lit';

export const planeParamsFormStyles = css`
  :host {
    display: block;
  }

  fieldset {
    margin: 0 0 var(--space-4);
    padding: var(--space-3) var(--space-4) 0;
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
  }

  legend {
    padding: 0 var(--space-2);
    font-weight: var(--font-weight-semibold);
  }

  .required {
    color: var(--tone-danger);
  }

  /* the assistants a field chooses among, one per line */
  .choices {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }
`;
